import CheckBox from "../../../../../components/checkBox/CheckBox";
import Utils from "../../../../../utils/Utils";
import React, {useEffect, useState} from "react";
import {setStateAssistente} from "../../../../../actions/IndexActions";
import {useDispatch, useSelector} from "react-redux";

function TrattamentoDatiPersonali(props) {

    const [state, setState] = useState({})
    const dispatch = useDispatch();
    const getAssistente = useSelector(state => state.wizardReducer)
    const [modifica,setModifica]=useState(false)
    useEffect(() =>{
        if(getAssistente && getAssistente.datiPersonali){
            let newState = getAssistente.datiPersonali
            setState(newState)
        }
        if (getAssistente && getAssistente.datiPersonali && getAssistente && getAssistente.assistente && getAssistente.assistente.idCandidato){
            setModifica(true)
        }
    },[])

    useEffect(() =>{
        dispatch(setStateAssistente("datiPersonali",state))
    },[state, setState])

    return (
        <div>
            <span style={{fontSize: "16px", fontWeight: "bold"}}>
                Termini e condizioni del servizio:
            </span>
            <fieldset disabled={modifica}>
            <div className={"row"}>
                <div className={"col-1"} style={{flex: "0 0 2%"}}>
                    <CheckBox id={"checkboxStep3TerminiCondizioni1"}
                              onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "terminiCondizioni"))}
                              checked={state && state.terminiCondizioni && state.terminiCondizioni.checkboxStep3TerminiCondizioni1 ? state.terminiCondizioni.checkboxStep3TerminiCondizioni1 : false}/>
                </div>
                <div className={"col-11"} style={{marginTop: ".6rem"}}>
                    <span>L'utilizzo del servizio dovrà avvenire nel rispetto delle leggi vigenti, della morale e dell'ordine pubblico.<br/>
                            A titolo esemplificativo e non esaustivo l'utente si impegna a:<br/>
                            a) Astenersi dal compiere violazioni dei sistemi e della sicurezza delle reti;<br/>
                            b) Utilizzare il servizio unicamente nei modi ed ai fini previsti dalle leggi vigenti;<br/>
                            c) Utilizzare il servizio in modo tale da non arrecare danno a se stesso e/o danno, anche indiretto, a terzi.<br/>
                            Le informazioni fornite dall'utente verranno archiviate su un servere presso il fornitore del servizio che ne curerà la sicurezza e la segretezza, mediante protocolli avanzati.
                            Il fornitore del servizio non sarà responsabile per danni e/o perdite sottrazioni di informazioni subiti dall'utente e dovuti a negligenza nella custodia della password per accedere al servizio.
                            I dati raccolti dal fornitore del servizio verranno trattati esclusivamente ai fini del servizio sia manualmente che con l'ausilio di mezzi elettronici, o comunque automatizzati, e comprendono,
                            nel rispetto dei limiti e delle condizioni poste dall'art. 11 D. Lgs 196/2003, tutte le operazioni, o complesso di operazioni, previste dallo stesso decreto con il termine "trattamento".
                            I dati personali raccolti non saranno oggetto di diffusione o comunicazione a terzi, se non nei casi previsti dalla informativa e/o dalla legge e, comunque, con le modalità da questa consentite.
                            L'interessato ha il diritto di conoscere, correggere, aggiornare i dati personali che lo riguardano o di chiederne la cancellazione.
                    </span>
                    <span className={"obbligatorietaColor"}>*</span>
                </div>
            </div>
            <div className={"row"}>
                <div className={"col-1"} style={{flex: "0 0 2%"}}>
                    <CheckBox id={"checkboxStep3TerminiCondizioni2"}
                              onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "terminiCondizioni"))}
                              checked={state && state.terminiCondizioni && state.terminiCondizioni.checkboxStep3TerminiCondizioni2 ? state.terminiCondizioni.checkboxStep3TerminiCondizioni2 : false}/>
                </div>
                <div className={"col-11"} style={{marginTop: ".6rem"}}>
                    <span>Autorizzo l'utilizzo dei dati personali indicati, ai sensi del D.Lgs. 196/2003 e del G.D.P.R. 679/2016, affinché siano conservati, raccolti, registrati, organizzati, utilizzati, selezionati e comunicati a soggetti
                          interessati alla gestione del servizio di "Assistenza Familiare". Dichiaro di essere stato informato, ai sensi e per gli effetti di cui all'art. 13 del D.Lgs. 196/2003 e dell'art. 13 del G.D.P.R. 679/2016
                    <span className={"obbligatorietaColor"}>*</span>
                    </span>
                </div>
            </div>
            </fieldset>
        </div>
    )
}

export default TrattamentoDatiPersonali
